<template>
    <div class="notification-container">
        <v-alert dismissible width="350px" dark dense v-for="(alert, index) in alerts" :key="index" :type="alert.type"
            border="left" elevation="2" prominent class="my-alert">
            {{ alert.message }}
        </v-alert>
    </div>
</template>
<script>
export default {
    data() {
        return {
            alerts: [],
            alertTypes: { 0: 'error', 1: 'success', 2: 'info', 3: 'warning' },
        };
    },
    methods: {
        show(message, typeIndex = 1, duration = 4000) {
            const alert = {
                message,
                type: this.alertTypes[typeIndex] || 'success',
            };
            this.alerts.push(alert);
            // console.log("From Global notifications: ");
            // console.log(this.alerts);
            setTimeout(() => {
                this.removeAlert(this.alerts.indexOf(alert));
            }, duration);
        },
        removeAlert(index) {
            if (index > -1) {
                this.alerts.splice(index, 1);
            }
        },
    },
};
</script>
<style scoped>
.notification-container {
    position: fixed;
    top: 10%;
    right: 20px;
    z-index: 2000;
    display: flex;
    flex-direction: column-reverse !important;
}

.my-alert {
    margin-top: 10px;
    position: relative !important;
}
</style>
